/** Player-only Pingflo flows — never keep these when the active home role is staff. */
export const PLAYER_ONLY_PROFILING_INTROS = new Set([
  "technical",
  "technicalUpdate",
  "smartGoals",
  "trainingAxes",
  "clubJoin",
]);

export function isStaffHomeRole(role) {
  return (
    role === "admin" ||
    role === "coach" ||
    role === "monitor" ||
    role === "moderator" ||
    role === "committee" ||
    role === "parent"
  );
}

/**
 * Resolve which home role Pingflo should speak as when opening.
 * Explicit player-only intros (technical profiling, SMART goals, …) keep player
 * only when the active picker is already player — a coach/admin who also plays
 * must never be pulled into their technical profile while that staff role is active.
 * Otherwise honor the active home-role picker.
 */
export function resolveDigipingOpenRole({
  requestedRole,
  activeRole,
  profilingIntro = null,
} = {}) {
  const active = activeRole || "player";
  // Active staff role always wins — even if the open event asks for player /
  // technical profiling (dual-role coach/admin who also plays).
  if (isStaffHomeRole(active)) {
    return active;
  }
  let role = requestedRole || active;
  if (
    role === "player" &&
    active !== "player" &&
    !PLAYER_ONLY_PROFILING_INTROS.has(profilingIntro)
  ) {
    role = active;
  }
  return role;
}

/** Drop player-only profiling intros when opening as admin/coach/etc. */
export function sanitizeProfilingIntroForRole(role, profilingIntro) {
  if (!profilingIntro) return null;
  if (role !== "player" && PLAYER_ONLY_PROFILING_INTROS.has(profilingIntro)) {
    return null;
  }
  return profilingIntro;
}

/** Roles that browse club groups + named players in Pingflo People chat. */
export function canBrowseClubChatRoster(role) {
  return (
    role === "admin" ||
    role === "coach" ||
    role === "committee" ||
    role === "moderator"
  );
}
